var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", { attrs: { d: "M0 0h24.747v24.747H0z" } }),
        _vm._v(" "),
        _c("g", { attrs: { fill: _vm.color } }, [
          _c("path", {
            attrs: {
              d: "M12.5 2.512c-1.152 0-2.325.993-3.218 2.724C8.288 7.163 7.74 9.743 7.74 12.5c0 2.757.547 5.337 1.54\n        7.264.894 1.73 2.067 2.724 3.219 2.724 1.152 0 2.325-.993 3.218-2.724.994-1.927 1.541-4.507 1.541-7.264\n        0-2.757-.547-5.337-1.54-7.264-.894-1.73-2.067-2.724-3.219-2.724m0 21.595c-3.577\n        0-6.379-5.098-6.379-11.607C6.121 5.991 8.923.893 12.5.893c3.577 0 6.379 5.098 6.379 11.607 0\n        6.509-2.802 11.607-6.379 11.607",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M12.5 7.74c-2.757 0-5.337.548-7.264 1.542-1.73.893-2.724 2.066-2.724 3.218 0\n        1.152.993 2.325 2.724 3.218 1.927.994 4.507 1.541 7.264 1.541 2.757 0 5.337-.547 7.264-1.54\n        1.73-.894 2.724-2.067 2.724-3.219 0-1.152-.993-2.325-2.724-3.218-1.927-.994-4.507-1.541-7.264-1.541m0\n        11.138C5.991 18.879.893 16.077.893 12.5c0-3.577 5.098-6.379 11.607-6.379 6.509 0 11.607 2.802\n        11.607 6.379 0 3.577-5.098 6.379-11.607 6.379",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }